module.exports = __webpack_public_path__ + "img/logo.5a2e3d73.png";